const en = {
  "templateList.synchronize.preview.tooltip": "Preview synchronization",
  "templateList.synchronize.preview.title": "Synchronization preview",
  "templateList.synchronize.preview.description": "This check does not change any data. It shows the changes synchronization would currently make for this template version.",
  "templateList.synchronize.preview.loading": "Comparing template data …",
  "templateList.synchronize.preview.error": "The preview could not be loaded. Please try again.",
  "templateList.synchronize.preview.duplicateKeys": "The template contains duplicate question or page IDs. Synchronization is blocked until IDs are unique for each item type across the entire template.",
  "templateList.synchronize.preview.blocked": "Synchronization blocked",
  "templateList.synchronize.preview.duplicateId": "Duplicate ID",
  "templateList.synchronize.preview.locations": "Locations in the template",
  "templateList.synchronize.preview.location.page": "Page {index}",
  "templateList.synchronize.preview.location.question": "Question {index}",
  "templateList.synchronize.preview.inactive": "This template version is no longer active. Please reload the template list.",
  "templateList.synchronize.preview.notPublished": "No published data exists for this template version. Synchronization would make no changes.",
  "templateList.synchronize.preview.multipleSurveys": "Multiple matching template structures were found. Synchronization uses the first match.",
  "templateList.synchronize.preview.noChanges": "The data matches. No changes are needed.",
  "templateList.synchronize.preview.summary": "{count, plural, one {# affected item} other {# affected items}}",
  "templateList.synchronize.preview.entity": "Item type",
  "templateList.synchronize.preview.CREATE": "Create",
  "templateList.synchronize.preview.UPDATE": "Update",
  "templateList.synchronize.preview.details": "Change details",
  "templateList.synchronize.preview.comparison": "Comparison of current and proposed values",
  "templateList.synchronize.preview.field": "Field",
  "templateList.synchronize.preview.before": "Current",
  "templateList.synchronize.preview.after": "Proposed",
  "templateList.synchronize.preview.unset": "Not set",
  "templateList.synchronize.preview.empty": "Empty text",
  "templateList.synchronize.preview.generated": "Assigned on creation",
  "templateList.synchronize.preview.yes": "Yes",
  "templateList.synchronize.preview.no": "No",
  "templateList.synchronize.preview.retry": "Retry",
  "templateList.synchronize.preview.entity.Survey": "Templates",
  "templateList.synchronize.preview.entity.QuestionGroup": "Pages",
  "templateList.synchronize.preview.entity.Question": "Questions",
  "templateList.synchronize.preview.entity.Answer": "Answers / choices",
  "templateList.synchronize.preview.entity.Indicator": "Indicators",
  "templateList.synchronize.preview.field.title": "Title",
  "templateList.synchronize.preview.field.description": "Description",
  "templateList.synchronize.preview.field.name": "Internal name",
  "templateList.synchronize.preview.field.surveyName": "Template name",
  "templateList.synchronize.preview.field.surveyRefId": "Template ID",
  "templateList.synchronize.preview.field.version": "Version",
  "templateList.synchronize.preview.field.reportTemplateYear": "Template year / month",
  "templateList.synchronize.preview.field.pageKey": "Page key",
  "templateList.synchronize.preview.field.questionKey": "Question key",
  "templateList.synchronize.preview.field.mandatory": "Required question",
  "templateList.synchronize.preview.field.type": "Question type",
  "templateList.synchronize.preview.field.orderIndex": "Order",
  "templateList.synchronize.preview.field.page": "Assigned page",
  "templateList.synchronize.preview.field.pageGid": "Page ID",
  "templateList.synchronize.preview.field.rowName": "Internal row name",
  "templateList.synchronize.preview.field.rowText": "Row label",
  "templateList.synchronize.preview.field.rowKey": "Row key",
  "templateList.synchronize.preview.field.colName": "Internal column name",
  "templateList.synchronize.preview.field.colText": "Column label",
  "templateList.synchronize.preview.field.colType": "Column type",
  "templateList.synchronize.preview.field.columnKey": "Column key",
  "templateList.synchronize.preview.field.text": "Answer label",
  "templateList.synchronize.preview.field.value": "Answer value",
  "templateList.synchronize.preview.field.choiceKey": "Choice key",
  "templateList.synchronize.preview.field.predefined": "Predefined",
  "templateList.synchronize.preview.field.isPredefined": "Predefined",
  "templateList.synchronize.preview.field.indicatorKey": "Indicator key",
  "templateList.synchronize.preview.field.indicatorRefId": "Indicator ID",
  "templateList.synchronize.preview.field.shortName": "Short name",
  "templateList.synchronize.preview.field.longName": "Long name",
  "survey.editor.validation.check": "Check template",
  "survey.editor.validation.downloadJson": "Download JSON",
  "survey.editor.validation.openWindow": "Open in new window",
  "survey.editor.validation.popupBlocked": "The new window could not be opened. Please allow pop-ups for this site and try again.",
  "survey.editor.validation.title": "Template check results",
  "survey.editor.validation.scope": "Checked: {pageCount} sections, {questionCount} questions and {triggerCount} triggers in the current draft.",
  "survey.editor.validation.summary": "Found {errors} errors and {warnings} warnings.",
  "survey.editor.validation.success": "No issues found with IDs or configured triggers.",
  "survey.editor.validation.ids": "IDs and internal names",
  "survey.editor.validation.triggers": "Triggers",
  "survey.editor.validation.noIssues": "No issues found.",
  "survey.editor.validation.error": "Errors",
  "survey.editor.validation.warning": "Warnings",
  "survey.editor.validation.page": "Section",
  "survey.editor.validation.question": "Question",
  "survey.editor.validation.column": "Column",
  "survey.editor.validation.row": "Row",
  "survey.editor.validation.option": "Option",
  "survey.editor.validation.missingColumnKey": "The column has no key (column ID).",
  "survey.editor.validation.missingRowKey": "The row has no key (row ID).",
  "survey.editor.validation.missingOptionKey": "The answer option has no key (answer ID).",
  "survey.editor.validation.duplicateKey": "The ID “{value}” is used more than once. Please use unique IDs.",
  "survey.editor.validation.duplicateName": "The internal name “{value}” is used more than once. References may be ambiguous.",
  "survey.editor.validation.unsupportedSource": "This question type or question without answer options does not support triggers.",
  "survey.editor.validation.invalidAnswer": "The triggering answer value “{value}” is missing or does not match an existing answer option.",
  "survey.editor.validation.unsupportedOperation": "The trigger uses an unsupported comparison or action. Supported values are EQ and ACTIVATE.",
  "survey.editor.validation.missingTarget": "The trigger target “{value}” is missing or has been deleted. Please select an existing target.",
  "survey.editor.validation.ambiguousTarget": "The trigger references multiple targets: its key or name is ambiguous or they refer to different elements.",
  "survey.editor.validation.staleReference": "The target key or internal name is outdated. Please select the target again.",
  "survey.editor.validation.wrongTargetType": "The stored target type does not match the referenced section or question.",
  "survey.editor.validation.selfReference": "The trigger references its own question or the section containing it.",
  "survey.editor.validation.visibleTarget": "The target is already visible by default, so the trigger has no additional visibility effect.",
  "survey.editor.validation.backwardTarget": "The target precedes the triggering question. Please check whether this backward reference is intended.",
  "survey.editor.validation.cycle": "The trigger is part of a cyclic dependency. Please check reachability and behavior when answers change.",
  "templateList.synchronize.tooltip": "Synchronize template version",
  "templateList.synchronize.success": "The template version was synchronized successfully.",
  "templateList.synchronize.duplicateKeys": "Synchronization blocked: The template contains duplicate question or page IDs. Run the preview to see the affected IDs and locations.",
  "templateList.synchronize.failed": "The template version could not be synchronized. It must be active and already published.",
  "login.headline": "Monitoring Portal",
  "login.loginButton": "Login",
  "login.placeholder.username": "Username",
  "login.placeholder.password": "Password",
  "login.error.0": "Service unavailable.",
  "autoLogin.error.0": "Service unavailable.",
  "login.error.401": "Invalid e-mail address or password. If you no longer have your password to hand, click on \"New password / Forgot password\"",
  "login.error.500":
    "This server is experiencing technical problems. Please try again in a few moments. Thanks for your continued patience.",
  "login.error.blocked":
    "The user account has been blocked. Please use the 'New Password / Forgot password' function below the input field for unblocking the account.",
  "login.forgot.password": "New password / Forgot password",
  "login.forgot.password.page.title": "New Password / Forgot password",
  "login.reset.password.page.title": "New Password / Reset Password",
  "login.back.to.login.page": "Back to Login Page",
  "login.password.reset.request.success.message":
    "An email has been sent to you. Please open the the contained link to reset your password.",
  "login.token.validation.failed.message": "The link you you opened is not valid anymore.",
  "login.please.specify.a.new.password": "Please type in a new password.",
  "login.please.enter.your.username": "Please enter your e-mail address to receive a link to set your password.",
  "login.password.resetted.success.message": "Your password was resetted successfully. You can now login.",
  "login.password.reset.user.not.found.or.inactive": "The user does not exist or has been deactivated",
  "login.password.reset.temporary.user":
    "This is a temporary user. The password cannot be reset. Please use your access link to edit reports.",
  "login.password.reset.request.timeout":
    "Sending the email is currently taking too long. Please try again later.",
  "login.password.reset.request.error":
    "The password reset link could not be sent. Please try again later.",
  "autoLogin.error.401": "Sorry, your SAP credentials did not match. Please try again.",
  "create.user.error.400": "User already exists",
  "maintenance.title": "Maintenance",
  "maintenance.text":
    "The monitoring tool is temporarily unavailable due to maintenance. Please try again later.",
  "maintenance.login.disabled": "Login is temporarily disabled due to maintenance.",

  "general.notification.downtime":
    "Please note: The DAAD Monitoring Tool will not be available on Thursday, 02.07.2026 from 05:00-13:00 CEST due to maintenance. We apologise for the inconvenience.",

  "app.header.help": "Help",
  "header.logout.button": "Logout",
  "header.clear.survey.caches": "Clear caches",
  "header.clear.survey.caches.success": "Survey caches were cleared successfully.",
  "header.clear.survey.caches.error": "Survey caches could not be cleared.",
  "app.footer.text": "© 2017, DAAD",
  "app.footer.banner.info": "We have modernised the user interface of the monitoring tool for you. The functionality has not changed;<br></br> you can edit and submit your reports as usual. You can find the revised manual <link>here</link>.",
  "app.common.All": "All",
  "app.common.Yes": "Yes",
  "app.common.No": "No",
  "app.common.Reset": "Reset",
  "app.common.Language": "Language",
  "app.common.Create": "Create",
  "app.common.Close": "Close",
  "app.common.Cancel": "Cancel",
  "app.common.Select": "Choose",
  "app.common.Export": "Export",
  "app.common.activate": "Activate",
  "app.confirmDialog.defaultTitle": "Are You sure?",
  "app.common.msg.error": "Oops... an unknown error just occurred. Please contact monitoring@daad.de (section S12).",
  "app.common.msg.backend": "Oops... an unknown error just occurred. Please contact monitoring@daad.de (section S12).",
  "app.common.msg.success": "Operation successful!",
  "app.common.Apply": "Apply",
  "app.common.confirm.deletion": "Confirm deletion",
  "app.common.title.error": "Error",
  "app.common.title.backend": "Error",
  "app.common.title.warning": "Warning",
  "app.common.title.info": "Information",
  "app.common.title.success": "Success",
  "app.common.title.actions": "Actions",
  "app.common.no.data": "No data found.",
  "app.common.field.error.required": "This field is required.",
  "app.session.expired": "Session expired",

  "app.validation.sizeMessage": "File is too large.",
  "header.qa.message": "QS-System",
  "header.dev.message": "DEV-System",

  "app.common.Copy": "Copy",
  "app.common.management": "Management",
  "app.common.role": "Role",
  "app.common.permissions": "Permissions",
  "app.common.organizational.unit": "Funding Area / Programme / Programme Instance / Project",

  "app.common.name": "Name",
  "app.common.name.english": "Name (english)",
  "app.common.name.german": "Name (german)",

  "app.common.action.edit": "Edit",
  "app.common.action.deactivate": "Deactivate",
  "app.common.action.delete": "Delete",
  "app.common.action.remove": "Remove",
  "app.common.action.cancel": "Cancel",
  "app.common.action.save": "Save",
  "app.common.action.move": "Drag & Drop",
  "app.common.action.show": "Show",
  "app.common.action.add": "Add",
  "app.common.action.submit": "Submit",
  "app.common.action.download": "Download",
  "app.common.action.take.over": "Take Over",
  "app.common.action.select.all": "Toggle All",
  "app.common.invalid_request": "Service unavailable",
  "app.common.unsaved_changes": "Unsaved changes",

  "language.english": "English",

  "language.german": "German",

  "user.welcome.message": "Welcome",

  "user.surveyBuilder.saveButton": "Save",
  "user.surveyBuilder.surveyTitle": "Title of survey template",
  "user.surveyBuilder.surveyTitlePlaceHolder": "Enter title",
  "user.surveyBuilder.reportTemplateYear": "Master template year and month",
  "user.surveyBuilder.reportTemplateYear.tooltip":
    "This year determines which template takes precedence in the program evaluation when multiple templates have been activated for the same reporting year. The template with the most recent date takes precedence. If multiple templates with the same year are used within a reporting year, the month can be used to determine which template takes precedence.",
  "survey.settings.save.thisVersion": "Save for this version only",
  "template.year.edit": "Change template date",
  "template.year.loadError": "The template date could not be loaded.",
  "template.year.saveError": "The template date could not be saved or the display could not be refreshed. Please reopen the dialog and check the value.",
  "survey.settings.save.followingVersions": "Save for this and all following versions",
  "survey.settings.reportTemplateYearInvalid": "Please select a year and month between 1000-01 and 9999-12.",
  "user.surveyBuilder.title": "Title",
  "user.surveyBuilder.applicableFor": "Applicable for",
  "user.surveyBuilder.fundingArea": "All Funding areas",
  "user.surveyBuilder.program": "All Programs",
  "user.surveyBuilder.program.instance": "All Instances",
  "user.surveyBuilder.project": "All Projects",
  "user.surveyBuilder.surveySettingsPanel.title": "Create survey template",
  "user.surveyBuilder.surveySettingsPanel.copy.title": "Copy survey template",
  "user.surveyBuilder.surveySettingsPanel.edit.title": "Change template settings",

  "user.surveyView.prev": "Prev",
  "user.surveyView.next": "Next",
  "user.surveyView.saveResult": "Save result",
  "user.surveyView.menuPages": "Sections",
  "user.surveyView.question": "Question",
  "user.surveyView.from": "from",
  "user.surveyView.radio.otherChoice": "Please specify",
  "user.surveyView.radio.otherChoice.input": "Other choice",
  "user.surveyView.table.addRow": "Add row",
  "user.surveyView.table.deleteRows": "Delete all rows",
  "user.surveyView.table.loadPrevPeriodQuestionAnswers": "Load previous year's data",
  "user.surveyView.table.loadPreviousReportQuestionAnswers": "Load latest report data",
  "user.surveyView.table.uploadCSV": "Upload CSV table",
    "user.surveyView.table.uploadCSV.append": "Add",
  "user.surveyView.table.uploadCSV.overwrite": "Replace",
  "user.surveyView.table.downloadExcel": "Download Excel template",
  "user.surveyView.table.downloadExcel.hint":
    "Please save the template as CSV file before uploading it. A detailed description can be found in the manual.",
  "user.surveyView.table.uploadCSV.hint":
    "You have the option to add rows by uploading a CSV file. Please note that column headings and selection options must match the given values in the table and **CSV format UTF-8** should be used for compability reasons. For further information, please refer to the user manual.  **For large lists, this process can take several minutes. Please do not close the report or the browser.**",
  "user.surveyView.table.uploadCSV.success":
    "The data could be retrieved ({rowCount} rows).  Please select whether you would like to **add** the retrieved data to the table or whether you would like to **delete and replace** any data that was previously entered or loaded from the previous year.",
  "user.surveyView.table.uploadCSV.values.parseError": "row {rowCount}, column '{importColumn}', value '{importValue}'",
  "user.surveyView.table.uploadCSV.columns.parseError": "column heading '{importValue}'",
  "user.surveyView.table.uploadCSV.parseError":
    "The following values do not match the table requirements. Please check the column and selection options in the CSV file.",
  "user.surveyView.table.uploadCSV.parseWarning":
    "The following columns do not match the table requirements and will be ignored for uploading.",
  "user.surveyView.table.mandatory.columns":
    "{completeColumns} of {columnLength} required columns completely answered. The following columns are incomplete:",
  "user.surveyView.table.rows.empty": "No entries",
  "user.surveyView.table.cell.empty": "Mandatory value",
  "user.surveyView.dropdown.choose": "Please choose",
  "user.surveyView.mandatory.field.tooltip":
    "Mandatory questions are marked with '*'. Also note columns in tables marked with '*'.",
  "user.surveyView.editing.disabled": "The report has been sent. Editing is not possible anymore.",
  "user.surveyView.editing.permission.disabled": "You have no permission to edit this report.",
  "user.surveyView.editing.read.only1": "The report {surveyName} is being edited by {lockByUser} since ",
  "user.surveyView.editing.read.only2": ". It is not possible to edit in parallel.",
  "user.surveyView.type.number": "Number",
  "user.surveyView.type.text": "Text",
  "user.surveyView.type.row": "Row",
  "user.surveyView.dialog.load.prev.result.not.found.title": "No previous data found",
  "user.surveyView.dialog.load.prev.result.not.found.text": "No previous data could found to take over",
  "user.surveyView.dialog.load.prev.result.title": "Previous data found",
  "user.surveyView.dialog.load.prev.result.text":
    "Data from the previous year were found for this question. Do you want to copy this data and overwrite all existing rows? Please remember to check and update the loaded data accordingly.",
  "user.surveyView.dialog.confirm.delete.all.rows": "Pleas confirm deleting all rows.",
  "user.surveyView.dialog.confirm.delete.single.row": "Pleas confirm deleting this row.",
  "user.surveyView.question.activity.modal.title": "Activitymonitoring",
  "user.surveyView.question.activity.modal.measure": "Measure",
  "user.surveyView.question.activity.modal.status": "current status",
  "user.surveyView.question.activity.modal.comment": "Comment",
  "user.surveyView.question.activity.filter.measurement": "measure filter",
  "user.surveyView.question.activity.filter.area": "area filter",
  "user.surveyView.question.activity.filter.status": "status filter",

  "app.validation.lengthMessage": "{currentLength, number} from available {length, number} characters",
  "app.validation.initialLengthMessage": "{text, number} from available {length, number} characters",
  "app.validation.rangeMessage": "Please enter a number between {minValue, number} and {maxValue, number}.",
  "app.validation.decimalMessage": "Allowed decimal scale {precision, number}",

  "templateList.filter": "Filter",
  "templateList.title": "Survey templates",
  "templateList.new.template": "New survey template",
  "templateList.templateTitle": "Title",
  "templateList.version": "Version",
  "templateList.updated": "Updated",
  "templateList.activations.versionUpdated": "Last edit of this version: {date}",
  "templateList.updatedBy": "Updated by",
  "templateList.status": "Status",
  "templateList.language": "Language",
  "templateList.history": "History",
  "templateList.edit": "Edit",
  "templateList.preview": "Preview",
  "templateList.status.draft": "Draft",
  "templateList.status.active": "Active",
  "templateList.sync.released": "Synced",
  "templateList.sync.unreleased": "Not synced",

  "templateList.tooltip.history": "History",
  "templateList.tooltip.activate": "Activate",
  "templateList.tooltip.activations.overview": "Activations overview",
  "templateList.tooltip.sync": "Sync",
  "templateList.tooltip.edit": "Edit",
  "templateList.tooltip.compare": "Compare",
  "templateList.tooltip.copy": "Copy",
  "templateList.tooltip.delete": "Delete",
  "templateList.tooltip.delete.activatedVersions": "This template cannot be deleted because activated versions exist.",
  "templateList.tooltip.delete.disabled": "It is not possible to delete an active template.",
  "templateList.tooltip.basic.edit": "Edit basic data",
  "templateList.tooltip.survey.preview": "Preview",
  "templateList.tooltip.pdf.create": "Create PDF",

  "templateList.compare.title": "Compare Survey Templates",

  "templateList.activations.activation": "Activation",
  "templateList.activations.lastVersionActivation": "Last activation of this version",
  "templateList.activations.activations": "Activations",
  "templateList.activations.preactivations": "Pre-activations",
  "templateList.activations.previous": "Previous",
  "templateList.activations.template.title": "Template title",
  "templateList.activations.activation.title": "Template title by activation",
  "templateList.activations.program.instance": "Program/Instance",
  "templateList.activations.program.instance.foreignid": "ID FP/FPI",
  "templateList.activations.reportingYear": "Reporting year",
  "templateList.activations.amount": "Number",
  "templateList.activations.semester.program.amount": "Number of activated reports",

  "indicatorList.indicatorModalPanel.title.placeholder": "Enter ID",
  "indicatorList.new.indicator": "Add Indicator",
  "indicatorList.edit.indicator": "Edit Indicator",
  "indicatorList.title": "Link indicator",
  "indicatorList.ID": "ID",
  "indicatorList.IndicatorShortVersion": "Indicator Short Version",
  "indicatorList.IndicatorLongVersion": "Indicator Long Version",
  "indicatorList.IndicatorShort": "Short",
  "indicatorList.IndicatorLong": "Long",
  "indicatorList.IndicatorShort.english": "Short description (english)",
  "indicatorList.IndicatorLong.english":
    "Description of the indicator according to the Indicator Toolbox (incl. differentiations) (English)",
  "indicatorList.IndicatorShort.german": "Short description (german)",
  "indicatorList.IndicatorLong.german":
    "Description of the indicator according to the Indicator Toolbox (incl. differentiations) (German)",
  "indicatorList.Level": "Level",
  "indicatorList.Indicator": "Indicator",
  "indicatorList.select": "Select Funding area",
  "indicatorList.program": "Programme",
  "indicatorList.fundingArea": "Funding area",
  "indicatorList.edit": "Edit",
  "indicatorList.id.500": "ID already exists. Please choose other ID",
  "indicatorList.id.empty": "ID can not be blank. Please choose ID",
  "indicatorList.fundingArea.empty": "Please choose a funding area",
  "indicatorList.programs.all": "All programs",
  "indicatorList.tooltip.edit": "Edit",

  "indicator.management.page.title": "Indicator Management",
  "indicator.management.new.action.field": "Create Action Field",
  "indicator.management.new.active.element": "Create Active Element",
  "indicator.management.new.indicator": "Create Indicator",
  "indicator.management.edit.action.field": "Edit Action Field",
  "indicator.management.edit.active.element": "Edit Active Element",
  "indicator.management.edit.indicator": "Edit Indicator",
  "indicator.management.action.field": "Action Field",
  "indicator.management.all.action.fields": "All Action Fields",
  "indicator.management.all.results": "All Results",
  "indicator.management.choose.action.field": "Choose Action Field...",
  "indicator.management.result": "Result",
  "indicator.management.indicator": "Indicator",
  "indicator.management.question": "Question",
  "indicator.management.action.fields": "Action Fields",
  "indicator.management.action.field.or.fields": "Action Field(s)",
  "indicator.management.results": "Results",
  "indicator.management.indicators": "Indicators",
  "indicator.management.questions": "Questions",
  "indicator.management.table.header.questions": "Questions",
  "indicator.management.question.preview": "Please click here for preview",
  "indicator.management.result.description.german": "Description (german)",
  "indicator.management.result.description.english": "Description (english)",
  "indicator.management.confirm.delete.action.field": "Please confirm deleting the action field.",
  "indicator.management.confirm.delete.result": "Please confirm deleting the result.",
  "indicator.management.confirm.delete.indicator": "Please confirm deleting the indicator.",
  "indicator.management.delete.action.field.not.possible":
    "Deletion failed. There are results linked to this action field.",
  "indicator.management.delete.result.not.possible": "Deletion failed. There are indicators linked to this result.",
  "indicator.management.delete.indicator.not.possible":
    "Deletion failed. There are questions linked to this indicator.",
  "indicator.management.indicator.title.german": "Title Indicator (german)",
  "indicator.management.indicator.title.english": "Title Indicator (english)",
  "indicator.management.indicator.question.german": "Question (german)",
  "indicator.management.indicator.question.english": "Question (english)",
  "indicator.management.indicator.code.invalid": "This ID is already in use",

  "survey.settings.choose.period": "Create reports for period",
  "survey.settings.activate.survey": "Activate Survey",
  "survey.settings.activate.survey.info":
    "For the selected program {numProjects} projects were found. After template activation no changes are possible.",
  "survey.settings.activate.survey.warning": "Are you sure you want to create reports for all projects?",
  "survey.settings.create.reports": "Create reports for",

  "dialog.leave.report": "Save report",
  "dialog.leave.message": "Your edits might get lost when leaving this page. Do you want to leave this page nevertheless?",
  "dialog.leave.message.with.details": "Unsaved changes in row(s): {rows}. Do you want to cancel and discard these changes?",
  "dialog.leave.with.saving": "Save and Exit",
  "dialog.leave.without.saving": "Exit",
  "dialog.dismiss": "Cancel",
  "dialog.delete": "Delete",
  "dialog.template.delete.title": "Delete Template",
  "dialog.template.delete.text": "Are you sure that you want to delete this template?",
  "dialog.respondents.overview.delete.title": "Delete report",
  "dialog.respondents.overview.delete.text": "Are you sure that you want to delete this report?",
  "dialog.respondents.overview.start.conversion.title": "Create ZIP/PDF",
  "dialog.respondents.overview.start.conversion.text": "There are {count} reports that can be converted into a ZIP file with PDF documents. This may take some time. Do you want to start the process?",

  "dialog.leave": "Leave template",
  "dialog.template.leave.title": "Leave Template",
  "dialog.template.leave.text": "If you leave template without saving, changes will be lost.",

  "dialog.leave.runner":
    'Your data has been saved. You can continue to edit your report now or at a later time. To finalize the report, please go to the details page and use the "Submit" button in the lower right corner.',
  "dialog.leave.runner.overview": "Continue",
  "dialog.leave.runner.details": "Go to Details Page",

  "runner.table.dialog.title.new": "Create New Table Row",
  "runner.table.dialog.title.edit": "Edit Table Row",
  "runner.error.dialog.title": "Unexpected error occurred",
  "runner.error.dialog.button.confirm": "OK",
  "runner.error.2.0.6":
    "This report has been changed in another session and cannot be saved anymore. Please reload the report again from the overview page.",
  "runner.error.1.0.1": "The report could not be saved. Please check your internet connection.",

  "overview.survey_templates": "Templates",
  "overview.survey": "Surveys",
  "overview.report": "Reports",
  "overview.admin": "Admin",
  "overview.indicators": "Indicators",
  "overview.users": "Users",
  "overview.projects": "Projects",
  "overview.respondents": "Respondents",
  "overview.lists": "Lists",
  "overview.masterdata": "Master Data",
  "overview.roles": "Roles",
  "overview.profile": "Profile",
  "overview.user.manual": "User Manual",
  "overview.user.manual.lecturer": "Manual for Lecturers",
  "overview.user.faq": "FAQ",

  "confirmDialog.title": "Dialog",
  "confirmDialog.text": "Are you sure?",
  "confirmDialog.confirmLabel": "Yes",
  "confirmDialog.dismissLabel": "No",
  "confirmDialog.ok": "Ok",
  "confirmDialog.cancel": "Cancel",

  "survey.editor.question": "Question",
  "survey.editor.page.key": "Section ID",
  "survey.editor.question.key": "Question ID",
  "survey.editor.choice.key": "Answer ID",
  "survey.editor.column.key": "Column ID",
  "survey.editor.row.key": "Row ID",
  "survey.editor.page.title": "Section title",
  "survey.editor.description": "Description",
  "survey.editor.infotext": "Infotext",
  "survey.editor.title.survey.edit": "Title of survey template",
  "survey.editor.exclusive": "Exclusive",
  "survey.editor.exclusive.info":
    "When project managers select an exclusive answer option, they cannot select any other option. Therefore, add relevant information to the answer option. Example: 'Language courses (Exclusive answer option)'",
  "survey.editor.save": "Save",
  "survey.editor.preview": "Preview",
  "survey.editor.title.edit": "Edit title and description",
  "survey.editor.choices": "Answer options",
  "survey.editor.confirm.page.deletion": "Are you sure you want to remove this section?",
  "survey.editor.rename.page": "Edit section title",
  "survey.editor.confirm.question.deletion": "Are you sure you want to remove this question?",
  "survey.editor.confirm.question.deletion.library":
    "This question is linked to the question library. The corresponding question in the library will be deleted at the next 'SYNC' operation.",
  "survey.editor.question.types": "Question Types",
  "survey.editor.confirm": "Confirm",
  "survey.editor.cancel": "Cancel",
  "survey.editor.toolbox.text": "Text",
  "survey.editor.toolbox.date": "Date",
  "survey.editor.toolbox.comment": "Comment",
  "survey.editor.toolbox.infoMessage": "Info Message",
  "survey.editor.toolbox.checkbox": "Checkbox",
  "survey.editor.toolbox.radio": "Radio",
  "survey.editor.toolbox.radioButton": "Radiobutton",
  "survey.editor.toolbox.radio.other": "Other field",
  "survey.editor.toolbox.radio.other.info":
    'Using this project managers can describe the option "Other" in more detail using free text.',
  "survey.editor.toolbox.dropdown": "Dropdown",
  "survey.editor.toolbox.predefinedList": "Predefined List",
  "survey.editor.toolbox.predefinedList.info": "Option-lists administered by S12 ready to be used as response options.",
  "survey.editor.toolbox.number": "Number",
  "survey.editor.toolbox.matrixChoice": "Matrix",
  "survey.editor.toolbox.matrixSingleChoice": "Matrix Single Choice",
  "survey.editor.toolbox.matrixMultipleChoice": "Matrix Multiple Choice",
  "survey.editor.toolbox.table": "Table",
  "survey.editor.toolbox.upload": "Upload",

  "survey.editor.toolbox.projectData": "Project data",
  "survey.editor.toolbox.projectData.information": "Project information",
  "survey.editor.toolbox.projectData.projectName": "Project name",
  "survey.editor.toolbox.projectData.projectNumber": "Project ID",
  "survey.editor.toolbox.projectData.fundingSum": "Total amount of funding",
  "survey.editor.toolbox.projectData.institution": "Grantee",
  "survey.editor.toolbox.projectData.faculty": "Faculty",
  "survey.editor.toolbox.projectData.emptyInfo": "No data available",
  "survey.editor.toolbox.projectData.hint":
    "This section will show project's data and the information of its contact persons.",
  "survey.editor.toolbox.projectData.contact": "Contact persons",
  "survey.editor.toolbox.projectData.no.contact": "No contact person found.",
  "survey.editor.toolbox.projectData.name": "Name",
  "survey.editor.toolbox.projectData.firstName": "First name",
  "survey.editor.toolbox.projectData.email": "E-Mail",
  "survey.editor.toolbox.projectData.role": "Role",
  "survey.editor.toolbox.projectData.firstFundingYear": "Funding begin",
   "survey.editor.toolbox.projectData.lastFundingYear": "Funding end",
  "survey.editor.toolbox.projectData.numberOfFundingYear": "Number of funding years",
  "survey.editor.toolbox.projectData.reportingYear": "Reporting year",
  "survey.editor.toolbox.projectData.assistent": "Project Assistant",
  "survey.editor.toolbox.projectData.lead": "Project Lead",
  "survey.editor.toolbox.projectData.project_assistant": "Project Assistant",
  "survey.editor.toolbox.projectData.project_responsible": "Project Lead",

  "survey.editor.toolbox.staticTable": "Static Table",
  "survey.editor.toolbox.staticTable.unnamed": "unnamed",
  "survey.editor.toolbox.dynamicTable": "Dynamic Table",
  "survey.editor.table.number": "Number",
  "survey.editor.table.text": "Text",
  "survey.editor.table.date": "Date",
  "survey.editor.table.singleChoice": "Single",
  "survey.editor.activity.list": "Activity list",
  "survey.editor.table.multipleChoice": "Multiple",
  "survey.editor.table.dropDown": "Dropdown",
  "survey.editor.required": "Required",
  "survey.editor.required.info":
    "Activate this slider to set a question as mandatory if this information is essential. Set a question as mandatory only if all universities can enter data about it. Additionally or alternatively, you can define individual columns within tables as mandatory fields.",
  "survey.editor.visible": "Visible",
  "survey.editor.indicator": "Indicator",
  "survey.editor.text.maxLength": "Max. characters",
  "app.validation.maxLengthReached": "Input not possible: A maximum of {length, number} characters is allowed.",
  "survey.editor.text.number.till": "till",
  "survey.editor.text.number.from": "von",
  "survey.editor.text.number.range": "Range",
  "survey.editor.text.number.suffix": "Suffix",
  "survey.editor.text.number.decimal": "Decimal places",
  "survey.editor.matrix.column.choices": "Column Choices",
  "survey.editor.matrix.column.choice": "Column",
  "survey.editor.matrix.row.choices": "Row Choices",
  "survey.editor.text.maxSize": "Max",
  "survey.editor.text.mb": "MB",
  "survey.editor.evaluate.since.funding.started": "Evaluate question since funding started",
  "survey.editor.evaluate.since.funding.started.info":
    'Activate this slider if the indicator "since funding started" is collected according to the indicator catalog.',
  "survey.editor.load.previous.data.enabled": "Enable takeover previous year's data",
  "survey.editor.load.previous.data.enabled.info":
    "Enable this slider to allow PVs/PAs to load their responses to a question from the previous year's report (especially useful for questions that have been collected since funding began and for questions whose responses require little or no adjustment from year to year).",
  "survey.editor.upload.csv.enabled": "CSV upload enabled",
  "survey.editor.upload.csv.enabled.info":
    "Enable this slider to allow PVs/PAs to download an Excel template, fill it out, and then upload it to the tool as a csv file (especially useful for tables that universities can work with during the year, such as for applications).",
  "survey.editor.question.configuration": "Configuration",

  "survey.editor.tooltip.page.add": "Add section",
  "survey.editor.tooltip.page.edit": "Edit section",
  "survey.editor.tooltip.page.delete": "Delete section",
  "survey.editor.tooltip.page.visibility": "Visibility (trigger function)",
  "survey.editor.tooltip.question.visibility": "Visibility (trigger function)",
  "survey.editor.tooltip.question.library": "Add to my library",
  "survey.editor.tooltip.question.library.indicator": "This question is linked to at least one standard indicator.",
  "survey.editor.tooltip.question.libraryQuestion": "This question was added from the Indicator toolbox.",
  "survey.editor.tooltip.question.myLibraryQuestion": "This question was added from My question library",
  "survey.editor.tooltip.question.trigger": "Edit trigger",
  "survey.editor.tooltip.question.trigger.add": "Add trigger",
  "survey.editor.tooltip.question.trigger.delete": "Delete trigger",
  "survey.editor.tooltip.question.delete": "Delete question",
  "survey.editor.tooltip.question.move": "Move question",
  "survey.editor.tooltip.question.copy": "Copy question",
  "survey.editor.tooltip.table.column.edit": "Edit column",
  "survey.editor.tooltip.table.column.add": "Add column",
  "survey.editor.tooltip.table.column.delete": "Delete column",
  "survey.editor.tooltip.table.column.move": "Move column",
  "survey.editor.tooltip.table.row.edit": "Edit row",
  "survey.editor.tooltip.table.row.add": "Add row",
  "survey.editor.tooltip.table.row.delete": "Delete row",
  "survey.editor.tooltip.table.row.move": "Move row",
  "survey.editor.tooltip.indicator.delete": "Delete indicator",

  "survey.editor.predefined.list.countries": "List of countries",
  "survey.editor.predefined.list.country_reduced":
    'Liste of member states of the"Organisation for islamic Collaboration"',
  "survey.editor.predefined.list.regions": "List of regions",
  "survey.editor.predefined.list.field_of_study": "List of fields of study",
  "survey.editor.predefined.list.subject_of_study": "List of subjects of study",
  "survey.editor.predefined.list.degree": "Liste of degrees",
  "survey.editor.predefined.list.subject_of_study_teacher": "List of subjects of study (teacher)",
  "survey.editor.predefined.list.states": "List of states",
  "survey.editor.indicators.none": "No indicator",
  "survey.editor.trigger.set_trigger": "Set Trigger",
  "survey.editor.trigger.answer": "If the answer is",
  "survey.editor.trigger.make_visible": "Make visible",
  "survey.editor.trigger.target.placeholder": "Please select a question or section",
  "survey.editor.trigger.target.group.pages": "Sections",
  "survey.editor.trigger.target.group.questions": "Questions",
  "survey.editor.trigger.target.group.visible": "Visible",
  "survey.editor.trigger.target.group.missing": "Not found",
  "survey.editor.trigger.target.visible": "visible",
  "survey.editor.trigger.target.missing": "not found",
  "survey.editor.trigger.warning.target_visible":
    "This target is already visible. A trigger therefore does not make it additionally visible in the questionnaire.",
  "survey.editor.trigger.warning.target_missing":
    "This target is referenced by the trigger but no longer exists as a question or section.",
  "survey.editor.message.template_saved": "Template saved successfully.",
  "survey.editor.message.template_saved.question.keys.message": "Your report template has been saved. However, it contains duplicate question IDs, so it cannot be activated. If you have any questions, please contact S12.",
  "survey.editor.message.template_saved.duplicate.keys.message": "Your report template has been saved. However, it contains duplicate section or question IDs, so it cannot be activated. If you have any questions, please contact S12.",
  "survey.editor.message.question_saved": "Question has been saved to the question library.",
  "survey.editor.message.template_synced": "Questions have been synced to the question library.",
  "survey.editor.message.version.compare.warning.message": "There is no previous version of this report that has been activated or the last activated version is the current one. A comparison with the penultimate activated version is displayed.",
  "survey.editor.message.version.compare.warning.title": "Note on version comparison",
  "survey.editor.question.linked.indicators":
    "This question is linked to following indicators and is only limited editable:",

  "survey.editor.date.year": "Year",
  "survey.editor.date.month": "Month",
  "survey.editor.date.day": "Day",

  "respondents.overview.download.pdf.reports.title": "Download PDF reports",
  "respondents.overview.download.pdf.reports.report.type": "Report type",
  "respondents.overview.download.pdf.reports.submission.date": "Submission date",

  "respondents.overview.pageTitle": "Surveys",
  "respondents.overview.button.new.report": "New Report",
  "respondents.overview.button.report.status": "Report status",
  "respondents.overview.button.pdf.reports": "PDF reports",
  "respondents.overview.title": "Title",
  "respondents.overview.universityName": "University",
  "respondents.overview.templateTitle": "Template title",
  "respondents.overview.fundingArea": "Funding area",
  "respondents.overview.program": "Programme",
  "respondents.overview.instance": "Programme Instance",
  "respondents.overview.location": "Location",
  "respondents.overview.project": "Project",
  "respondents.overview.reportPeriod": "Period",
  "respondents.overview.status": "Status",
  "respondents.overview.lastEdit": "Last edit",
  "respondents.overview.tooltip.edit": "Edit report",
  "respondents.overview.tooltip.status": "Status of report",
  "respondents.overview.project.id": "Project ID",
  "respondents.overview.lecturer": "Lecturer",
  "respondents.overview.project.id.do.not.exist": "Not applicable",
  "respondents.overview.period.name": "Academic year",

  "respondents.overview.report.activation.title": "Report",
  "respondents.overview.report.activation.project": "Location",
  "respondents.overview.report.activation.choose.project": "Please choose a location",
  "respondents.overview.report.activation.choose.period": "Please choose a report period",
  "respondents.overview.report.activation.choose.template": "Please choose a report template",
  "respondents.overview.report.activation.no_templates_available": "No report templates are available for activation for the selected location and reporting period.",
  "respondents.overview.report.activation.template_must_be_choosen": "Please select template",
  "respondents.overview.report.activation.succeeded": "Your report template has been successfully activated.",
  "respondents.overview.report.activation.not_published": "This report template is already activated for the given reporting period.",
  "respondents.overview.report.activation.invalid": "The template could not be activated. Please contact S12.",

  "respondents.overview.status.IN_PROGRESS": "In Progress",
  "respondents.overview.status.COMPLETED": "Completed",
  "respondents.overview.status.SENT": "Sent",
  "respondents.overview.status.CLOSED": "Closed",
  "respondents.overview.status.NEW": "New",
  "respondents.overview.status.OBSOLETE": "Obsolete",

  "respondents.overview.search.placeholder": "Search...",
  "respondents.overview.filter.label": "Filter",
  "respondents.overview.filter.all": "All",

  "respondents.detail.page": "Chapter",
  "respondents.detail.page.unknown": "Unknown",
  "respondents.detail.progress": "Progress",
  "respondents.detail.required.questions": "All mandatory questions answered?",
  "respondents.detail.firstEdit": "first edit",
  "respondents.detail.respondent": "Responsible",
  "respondents.detail.edit": "Edit",
  "respondents.detail.status": "Status: ",
  "respondents.detail.lastEditAt": "Last edit at",
  "respondents.detail.editBy": "by",
  "respondents.detail.submittedAt": "Submitted at",
  "respondents.detail.printButton": "Print",
  "respondents.detail.downloadButton": "Download",
  "respondents.detail.respondentenButton": "Add respondents",
  "respondents.detail.submitButton": "Send",
  "respondents.detail.submitButton.RL": "Send",
  "respondents.detail.submitButton.BL": "Send",
  "respondents.detail.submitButton.AD": "Submit",
  "respondents.detail.survey.period": "Survey period",
  "respondents.detail.run.survey": "Show and edit",
  "respondents.detail.run.survey.readOnly": "Show report",
  "respondents.detail.progress.description": "{count} of {total} mandatory questions",
  "respondents.detail.pdf": "PDF",
  "respondents.detail.change.respondent": "Change respondent",
  "respondents.detail.change.respondent.text":
    "The change of the accountable respondent is intended to " +
    "visualize the responsibility for editing a particular section. The change has an informative character only. " +
    "No system-related changes will be triggered.",
  "respondents.detail.submit.button.tooltip": "Please answer all mandatory questions in order to submit report.",
  "respondents.detail.submit.button.disabled": "You don't have the permission to submit surveys.",
  "respondents.detail.status.NEW": "New",
  "respondents.detail.status.OBSOLETE": "Obsolete",
  "respondents.detail.status.IN_PROGRESS": "In Progress",
  "respondents.detail.status.SENT": "Sent",
  "respondents.detail.status.CLOSED": "Closed",
  "respondents.detail.status.change": "Change status",
  "respondents.detail.question.required.warning": "Some mandatory information is still missing from the report. Please click on the red arrows to complete the information.",

  "template.activation.title": "Activate template",
  "template.activation.invalid_data": "No projects available or already activated.",
  "template.activation.invalid_request": "Service unavailable",
  "template.activation.template_not_in_lectorate":"It is not possible to pre-activate report templates from other programmes for the lecturer programme. Select a report template from the lecturer programme.",
  "template.activation.duplicate_key":
    "Duplicate IDs have been found. Please contact S12.",
  "template.activation.program_must_be_choosen": "Please choose programme.",
  "template.activation.succeeded": "Your survey tool has been successfully activated and is now ready for reporting.",
  "template.activation.pre_activation_succeeded": "Your survey tool has been successfully pre-activated. Lectors can now use it for their reporting.",

  "respondents.detail.sendReminder": "Send reminder",

  "manage.survey.user.title": "Manage respondents",
  "manage.survey.user.edit.title": "Edit respondent",
  "manage.survey.user.send_email": "Send E-Mail",
  "manage.survey.user.name": "Name",
  "manage.survey.user.lastname": "Last Name",
  "manage.survey.user.email": "E-Mail",
  "manage.survey.user.expiration.date": "Expiration Date",
  "manage.survey.user.link": "Link",
  "manage.survey.user.inactive.users": "Show Inactive Responders",
  "manage.survey.user.inactive.validity": "Validity",
  "manage.survey.user.create": "Create respondent",
  "manage.survey.user.add": "Add",
  "manage.survey.user.update": "Update",
  "manage.survey.user.email.text":
    "You are invited to edit a report of a DAAD-funded project. Please click the following link to get temporary access to the DAAD Monitoringtool.\r\n\r\n—\r\n",
  "manage.survey.user.email.subject": "Access Monitoringtool DAAD",
  "manage.survey.user.copy": "Copy link",
  "manage.survey.user.deactivate": "Deactivate",
  "manage.survey.user.deactivate.first.part": "Do your really want to deactivate the selected respondent?",
  "manage.survey.user.deactivate.second.part":
    "The access to the tool will be denied and the link is invalid. The respondent will not have access to the report.",
  "manage.survey.user.deactivate.third.part": "You are able to reactivate users by defining a new expiration date.",
  "manage.survey.user.show.link.first.part":
    "The respondent has been successfully created and has access to the monitoring tool using the following link:",
  "manage.survey.user.show.link.second.part": "Please send this link to the respondent.",
  "manage.survey.user.username.already.exists": "This email address already exists in the system",
  "manage.survey.user.send.user.notification": "Notify user via e-mail",

  "status.of.survey.send.dialog.title": "Submit a report",
  "status.of.survey.send.dialog.title.RL": "Send report",
  "status.of.survey.send.dialog.title.AD": "Submit report",
  "status.of.survey.send.dialog.text1": "Are you sure you want to finish editing survey and send data to DAAD?",
  "status.of.survey.send.dialog.text1.RL":
    "Sind Sie sicher, dass Sie die Bearbeitung abschließen und den Bericht an die nächsthöhere Ebene geben wollen? Eine weitere Bearbeitung ist nur nach erneutem Freischalten durch Ihre Führungskraft möglich.",
  "status.of.survey.send.dialog.text1.AD":
    "Sind Sie sicher, dass Sie die Bearbeitung abschließen möchten? Nach Einreichen des Berichts sind keine Änderungen mehr möglich.",
  "status.of.survey.send.dialog.text2": "No changes are possible after sending data.",
  "status.of.survey.send.dialog.text2.RL":
    "Bevor Sie die Angaben senden, haben Sie die Möglichkeit ein PDF des jetzigen Standes herunterzuladen.",
  "status.of.survey.send.dialog.text2.AD":
    "Bevor Sie Ihre Angaben senden, haben Sie die Möglichkeit ein PDF Ihres Berichts herunterzuladen.",
  "status.of.survey.change.status.dialog.text1":
    "Please change status to 'Closed', when report is complete and approved.",
  "status.of.survey.change.status.dialog.text2":
    "In order to open the report for editing, please change status to 'In Progress'.",
  "status.of.survey.change.status.dialog.text2.BL":
    "To enable editing of the report by the work unit assigned to you again, set the status to 'In progress'. This allows adjustments from your review to be inserted by the author him/herself.",
  "status.of.survey.change.status.dialog.obsolete.text1":
    "You can set the status to 'Obsolete', if the already activated report is not to be edited and submitted.",
  "status.of.survey.change.status.dialog.obsolete.text2": "Attention: This operation can not be undone.",
  "status.of.survey.change.status.confirm.dialog.text": "Are you sure that you want to change status?",
  "status.of.survey.send.dialog.info":
    "You have answered {totalProgress}% of all questions. Please contribute to a better data quality by answering all questions of the report.",

  "evaluation.title": "Reports",
  "evaluation.tabs.indicators": "Indicators",
  "evaluation.tabs.programs": "Programs",
  "evaluation.tabs.projects": "Projects",
  "evaluation.tabs.achievement": "Objectives",

  "heartbeat.jwt.verification":
    "Your session has expired. Please login again via DAAD Portal or with your user credentials.",

  "master.data.management.page.title": "Master Data Management",
  "master.data.management.master.data": "Master Data",
  "master.data.management.funding.area": "Funding Area",
  "master.data.management.program": "Program",
  "master.data.management.program.table.numerical": "numeric",
  "master.data.management.program.table.percentage": "percentage",
  "master.data.management.program.instance": "Program Instance",
  "master.data.management.program.instances": "Program Instance(s)",
  "master.data.management.project": "Project",
  "master.data.management.lectorate": "Location",
  "master.data.management.edit": "Edit",
  "master.data.management.new.program": "Create Program",
  "master.data.management.new.program.instance": "Create Program Instance",
  "master.data.management.new.project": "Create Project",
  "master.data.management.edit.program": "Edit Program",
  "master.data.management.edit.program.instance": "Edit Program Instance",
  "master.data.management.edit.project": "Edit Project",
  "master.data.management.program.name": "Name",
  "master.data.management.project.university": "University",
  "master.data.management.project.targetRegion": "Region",
  "master.data.management.project.targetCountry": "Country",
    "master.data.management.project.projectType": "Type",
  "master.data.management.program.instance.name": "Name",
  "master.data.management.project.name": "Name",
  "master.data.management.button.save": "Save",
  "master.data.management.button.cancel": "Cancel",
  "master.data.management.button.successfully.save": "Successfully saved",
  "master.data.management.funding.area.foreignid": "Funding Area ID",
  "master.data.management.program.foreignid": "PKZ",
  "master.data.management.program.code": "Abbreviation (Code)",
  "master.data.management.program.instance.foreignid": "FPI",
  "master.data.management.project.foreignid": "Project ID",
  "master.data.management.lectorate.foreignid": "Location ID",
  "master.data.management.confirm.delete.project": "Please confirm deleting the project.",
  "master.data.management.confirm.delete.program.instance": "Please confirm deleting the program instance.",
  "master.data.management.confirm.delete.program": "Please confirm deleting the program.",
  "master.data.management.button.successfully.delete": "Successfully deleted.",
  "master.data.management.project.cannot.be.deleted": "The project cannot be deleted because reports exists",
  "master.data.management.project.deletion.not.possible": "Deleting not possible",
  "master.data.management.project.active": "Active",
  "master.data.management.project.obsolet": "Obsolet",
  "master.data.management.table.only.active.projects": "Show only active projects",

  "role.management.page.title": "Role Administration",
  "role.management.table.column.name": "Name",
  "role.management.table.column.title": "Title",
  "role.management.table.column.permissions": "Permissions",
  "role.management.table.column.scope": "Assignment Level",
  "role.management.new.role": "Create Role",
  "role.management.role.name": "Name",
  "role.management.role.title.german": "Title (german)",
  "role.management.role.title.english": "Title (english)",
  "role.management.create.new.role": "Create new Role",
  "role.management.edit.role": "Edit Role",
  "role.management.available.permissions": "Available Permissions",
  "role.management.assigned.permissions": "Assigned Permissions",
  "role.management.confirm.delete.role": "Please confirm deletion of the role.",
  "role.management.role.scope.project": "Project",
  "role.management.role.scope.program": "Program",
  "role.management.role.scope.fundingarea": "Funding Area",
  "role.management.role.scope.programInstance": "Program Instance",
  "role.management.role.scope": "Assignment Level",

  "user.management.page.title": "User Management",
  "user.management.new.user": "Create User",
  "user.management.table.username": "Username (Email address)",
  "user.management.table.firstname": "Firstname",
  "user.management.table.lastname": "Lastname",
  "user.management.table.employeeNumber": "Identifier (optional)",
  "user.management.table.roles": "Roles",
  "user.management.table.permissions": "Permissions",
  "user.management.table.permissions.hint":
    "Assign or unassign permissions using the respective buttons or by drag and dropping them to the respective box.",
  "user.management.table.units": "Units",
  "user.management.table.status": "Status",
  "user.management.table.active": "Active",
  "user.management.table.only.active.users": "show only active users",
  "user.management.table.only.unnotified.users": "show only users without account notification",
  "user.management.search.placeholder": "Search in user management...",
  "user.management.search.aria": "Search in user management",
  "user.management.action.activate": "Activate",
  "user.management.action.deactivate": "Deactivate",
  "user.management.create.new.user": "Create a new user",
  "user.management.create.new.user.password": "Password",
  "user.management.create.new.user.administrator": "Administrator",
  "user.management.create.new.user.save": "Save",
  "user.management.create.new.user.cancel": "Cancel",
  "user.management.create.new.user.password.warning":
    "Password must have between {MIN_PASSWORD_CHARS} and {MAX_PASSWORD_CHARS} characters.",
  "user.management.create.new.user.username.warning": "Please input a valid email address as username.",
  "user.management.user.activate": "Do you want to activate user {username}?",
  "user.management.user.deactivate":
    "All permissions will be removed for deactivated users. Do you want to deactivate user {username}?",
  "user.management.edit.user": "Edit user",
  "user.management.edit.send.user.account.notification": "Send User Account Notification Mail",
  "user.management.edit.send.user.account.notification.confirm": "Please confirm sending the the notification",
  "user.management.create.new.user.exists.warning": "User already exists.",
  "user.management.create.new.role.exists.warning": "Role already exists.",
  "user.management.create.new.user.available.roles": "Available roles",
  "user.management.create.new.user.roles": "User roles",
  "user.management.users.per.page": "Users",
  "user.management.edit.effective.permissions": "Effective Permissions",
  "user.management.role.assignments": "Role assignments",
  "user.management.history.title": "Permission history",
  "user.management.history.loading": "Loading history …",
  "user.management.history.empty": "No changes have been recorded yet.",
  "user.management.history.date": "Date",
  "user.management.history.change": "Change",
  "user.management.history.change.ASSIGNED": "Assigned",
  "user.management.history.change.ROLE_CHANGED": "Role changed",
  "user.management.history.change.REVOKED": "Revoked",
  "user.management.history.change.USER_DEACTIVATED": "User deactivated",
  "user.management.history.change.USER_ACTIVATED": "User activated",
  "user.management.history.source": "Source",
  "user.management.history.source.MANUAL": "User management",
  "user.management.history.source.SAP": "SAP",
  "user.management.history.source.BULK_IMPORT": "Bulk import",
  "user.management.history.source.SYSTEM": "System",
  "user.management.history.actor": "Changed by",
  "user.management.choose.role": "Choose Role",

  "user.management.roles.admin": "Admin;",
  "user.management.roles.evaluation_ind_viewer": "Analysis indicators view;",
  "user.management.roles.evaluation_obj_viewer": "Analysis objectives view;",
  "user.management.roles.evaluation_prg_viewer": "Analysis programmes view;",
  "user.management.roles.evaluation_prj_viewer": "Analysis projects view;",
  "user.management.roles.evaluation_viewer": "Navigation analysis view;",
  "user.management.roles.indicator_viewer": "Navigation indicators view;",
  "user.management.roles.survey_viewer": "Navigation surveys view;",
  "user.management.roles.template_creator": "Survey templates edit;",
  "user.management.roles.template_viewer": "Navigation survey templates view;",
  "user.management.roles.user": "User;",
  "user.management.roles.user_editor": "User management edit;",
  "user.management.roles.user_viewer": "User management view;",
  "user.management.roles.indicator_editor": "Indicators view;",
  "user.management.roles.temporary_user": "Temporary user;",
  "user.management.roles.library_viewer": "Library viewer;",
  "user.management.roles.library_editor": "Library editor;",
  "user.management.roles.program_admin": "Program Admin;",
  "user.management.roles.master_data_viewer": "Master Data viewer;",
  "user.management.roles.master_data_editor": "Master Data editor;",
  "user.management.roles.role_editor": "Role Editor;",
  "user.management.roles.survey_submitter": "Survey submission;",
  "user.management.roles.survey_key_editor": "Question-ID editor;",
  "user.management.roles.survey_respondent_editor": "Respondent editor;",
  "user.management.roles.survey_editor": "Survey editing;",
  "user.management.please.choose.a.project": "Choose a project",
  "user.management.please.choose.a.unit": "Choose organizational unit",

  "pagination.page": "Page",
  "pagination.of": "of",
  "pagination.previous": "Previous",
  "pagination.next": "Next",
  "pagination.showing": "Showing page {current} of {total}",

  "table.chart.chose.program": "Please choose a program to see the statistics.",
  "indicator.chart.choose.funding.area": "Please choose a funding area.",
  "indicator.chart.choose.group": "Please choose an indicator.",
  "indicator.chart.choose.time_facet": "Please choose at least one reporting year.",
  "indicator.chart.changed.filter.criteria": "Please apply your changed filter criteria to updated the view",
  "indicator.chart.legend": "Legend",
  "indicator.chart.legend.report.amount": "Number of analysed reports",
  "indicator.chart.legend.project.amount": "Number of reports who answered this question",
  "indicator.chart.legend.results.sum": "Sum of occurrences",
  "collapsible.program.required": "Please select a funding area and a program.",
  "collapsible.program.instance.required": "Please select at least one program instance.",
  "collapsible.question.group.required": "Please select a section.",
  "collapsible.no.question.groups.found": "No data found for the current filter criteria.",
  "collapsible.year.required": "Please select at least one reporting year and then desired the program instances.",
  "collapsible.changed.filter.criteria":
    'Please apply your changed filter criteria to updated the view. The option "since funding started" will be reset for all questions.',
  "collapsible.download.downloadAll": "Export static data",
  "collapsible.download.downloadAll.helperText":
    "Contains one line per project with all static data from the following question types: selection multiple, selection single, numberfield, matrix, date and static table.\n" +
    'Answers from textfields are in a separate file (button: "export Textboxes and -fields").Data from dynamic tables are in the single files of the download (button: "Export all data (ZIP)").',
  "collapsible.download.downloadTexts": "export Textboxes and -fields",
  "collapsible.download.downloadTexts.helperText":
    'Contains one line for each project with the answers from textboxes and -fields outside of table questions. Textfields inside of tables are contained in the static data (button: "export static data") e.g. the data of a dynamic table (button: "Export all data (ZIP)")',
  "collapsible.download.downloadZip": "Export all data (ZIP)",
  "collapsible.download.downloadZip.helperText":
    "Contains a ZIP-file with all data exported into different files: one file for statistical data, one file with answers in text fields and one file per dynamic table.",
  "collapsible.download.downloadPdf": "Export reports (PDF)",
  "collapsible.download.downloadPdf.helperText":
    "Contains a ZIP-file with all reports for the selected timeframe as single files in PDF-format.",
  "collapsible.download.downloadAAPdf": "Export AA-reports (PDF)",
  "collapsible.download.downloadAAPdf.helperText":
    "Contains a ZIP-file with all reports for the selected timeframe as single files in PDF-Format for disclosure to the federal foreign office.",
  "collapsible.download.downloadRueckPdf": "Export handover reports (PDF)",
  "collapsible.download.downloadRueckPdf.helperText":
    "Contains a ZIP-file with all reports for the selected timeframe as single files in PDF-Format but with only the answers to questions that were directed for the disclosure to the new lector.",
  "collapsible.table.nodata": "No data found for the selected filters.",
  "collapsible.filter.reportingYear": "Reporting period",
  "collapsible.filter.reportingYear.info": "Only reports submitted in the selected years will be counted.",
  "collapsible.filter.reportingYear.warning":
    "Data were not found for all requested reporting years! Data is available for the following years: ",
  "collapsible.filter.reportingYear.warningTitle":
    "The title of this question has changed in the selected reporting years.",
  "collapsible.filter.status": "Only submitted reports",
  "collapsible.filter.finalReport": "Only final reports",
  "collapsible.filter.projectCount": "Number of selected reports: ",
  "collapsible.filter.surveyTemplates": "Survey templates used",
  "collapsible.filter.sinceFundingStarted": "since funding started",
  "collapsible.filter.sinceFundingStarted.text":
    'Durch Aktivieren dieser Option werden von jedem Projekt nur die Werte des letzten vorliegenden Sachberichtes ausgegeben. Aktivieren Sie diese Funktion bei Fragen bzw. Indikatoren, "die seit Förderbeginn" abgefragt werden, um Doppelzählungen zu vermeiden. Bei Indikatoren, die "im Berichtszeitraum" abgefragt werden, ist diese Option nicht einzusetzen.',
  "collapsible.table.question.group": "Sections",
  "collapsible.table.question.group.template.info": "The section structure corresponds to the template: {name}, version {version}.",
  "collapsible.table.question.group.previous.templates": "Questions from previous templates",
  "collapsible.table.question.total": "Total",
  "collapsible.table.label.table": "Table",
  "collapsible.table.label.chart": "Diagram",
  "collapsible.filter.pivot.button.name": "Pivot Table",
  "collapsible.filter.pivot.button": "create pivot table",
  "collapsible.filter.pivot.button.project": "Pivot table Project",
  "collapsible.filter.pivot.button.reporting.year": "Pivot table reporting year",
  "collapsible.filter.pivot.button.region": "Pivot table region",
  "collapsible.filter.pivot.button.country": "Pivot table country",
  "collapsible.filter.pivot.modal.title": "Pivot table selection",
  "collapsible.filter.pivot.modal.section": "choose section",
  "collapsible.filter.pivot.modal.question": "choose question",
  "collapsible.filter.pivot.modal.field": "choose field",
  "collapsible.filter.pivot.modal.field.total": "entire table",
  "collapsible.table.chart": "Chart",
  "collapsible.no.reports.for.selection.warning": "No reports for the current selection.",
  "evaluation.tabs.collapsible": "Evaluation Programs",
  "collapsible.table.question.number.of.rows": "Number of rows",
  "indicator.chart.apply.filters": "Apply Filter Criteria",

  "question.library.set.question.name": "Question Title",
  "question.library.set.question.id": "ID",
  "question.library.toolbox": "Indicator toolbox",
  "question.library.toolbox.my": "My question library",
  "section.library.title": "My section library",
  "library.savedAt": "Saved at",
  "library.elementTitle": "Title",
  "library.origin": "Original template",
  "library.insertSelected": "Insert selection",
  "library.delete": "Delete",
  "library.questionPreview": "Show questions",
  "section.library.saveCurrent": "Save current section",
  "section.library.save": "Save to section library",
  "section.library.saveAction": "Save to library",
  "survey.editor.page.visibility": "Visibility",
  "survey.editor.page.visible": "Section visible",
  "section.library.name": "Library name",
  "section.library.sourceTemplate": "Original template",
  "section.library.sourceTemplateUnknown": "Unknown",
  "section.library.questions": "Questions",
  "section.library.actions": "Actions",
  "section.library.empty": "You have not saved any sections yet.",
  "section.library.loading": "Updating section library …",
  "section.library.saved": "The section has been saved to your library.",
  "section.library.error": "The request could not be completed. Please try again.",
  "section.library.insert": "Insert section",
  "section.library.delete": "Delete",
  "section.library.deleteConfirm": "Delete section “{name}” from your library? Previously inserted copies will be retained.",
  "section.library.copyHint": "The section and all its questions will be added to the current template as a copy. After inserting, check triggers and visibility settings.",
  "section.library.keyCollision": "Inserting this section creates duplicate section or question IDs. Please review and resolve the duplicates and affected triggers in the template.",
  "section.library.externalTriggers": "This section contains triggers targeting items outside the section. These targets will not be copied. Reassign the affected triggers in the editor after inserting and check the visibility of the section and its questions.",
  "question.library.toolbox.library": "Select question templates",
  "question.library.toolbox.custom": "Create questions individually",
  "survey.editor.add.question.library.title": "Indicator toolbox",
  "survey.editor.add.question.library.title.my": "My question library",
  "survey.editor.edit.question.library.title": "Edit Question",
  "survey.editor.add.question": "Add",
  "survey.editor.add.question.question.title": "Title",
  "survey.editor.add.question.question.origin": "Saved from",
  "survey.editor.add.question.question.type": "Type",
  "question.library": "Question Library",
  "question.library.all": "All",
  "question.library.preview.image": "Preview Image",

  "question.library.language.text": "Text",
  "question.library.language.date": "Date",
  "question.library.language.comment": "Comment",
  "question.library.language.infoMessage": "Info Message",
  "question.library.language.checkbox": "Checkbox",
  "question.library.language.radio": "Radio",
  "question.library.language.dropdown": "Dropdown",
  "question.library.language.predefinedList": "Predefined List",
  "question.library.language.number": "Number",
  "question.library.language.matrixSingleChoice": "Matrix Single Choice",
  "question.library.language.matrixMultipleChoice": "Matrix Multiple Choice",
  "question.library.language.staticTable": "Static Table",
  "question.library.language.staticTable.cols": "Columnview",
  "question.library.language.staticTable.rows": "Rowview",
  "question.library.language.dynamicTable": "Dynamic Table",
  "question.library.deletion.not.possible.dialog.title": "Deletion not possible",
  "question.library.deletion.not.possible.dialog.message":
    "The question could not be deleted because it is used in at least one indicator.",
  "question.library.deletion.confirm.referencing.templates.title": "Confirm deletion",
  "question.library.deletion.confirm.referencing.templates.message":
    "The question is already used in at least one survey template. Do you still want to delete it from “My question library”?",
  "question.library.question.id.invalid": "This ID is already in use",

  "app.error.unknown": "An unknown error occurred during processing of your request.",

  "user.profile.page.title": "My Profile",
  "user.profile.form.firstname": "First Name",
  "user.profile.form.lastname": "Last Name",
  "user.profile.update.password.dialog.title": "Change password",
  "user.profile.form.current.password": "Current Password",
  "user.profile.form.new.password": "New Password",
  "user.profile.form.new.password.confirm": "New Password (confirmation)",
  "user.profile.form.new.password.invalid.message":
    "Password must have between {MIN_PASSWORD_CHARS} and {MAX_PASSWORD_CHARS} characters.",
  "user.profile.form.new.password.confirm.invalid.message": "The password confirmation is not correct.",
  "user.profile.button.change.password": "Change Password",
  "user.profile.reponse.error.current.password.incorrect": "The current password is not correct",
  "user.profile.message.password.change.successful": "You have change your password successfully.",

  "question.preview": "Question Preview",

  "table.dialog.previousRow": "Previous row",
  "table.dialog.nextRow": "Next row",

  "temporary.user.create.error":
    "The temporary user could not be created because the username is being used for a regular account.",

  "template.question.sync.dialog.title": "Synchronize questions",
  "template.question.sync.dialog.message":
    "You are about to synchronize the changed questions into the question library. Do you want to continue?",

  "survey.version.compare.page": "Section",
  "survey.version.compare.question": "Question",
  "survey.version.compare.rowCol": "Column/Row",
  "survey.version.compare.rows": "Rows",
  "survey.version.compare.columns": "Columns",
  "survey.version.compare.choice": "Option",
  "survey.version.compare.type": "Type",
  "survey.version.compare.key": "Key",
  "survey.version.compare.change": "Change",
  "survey.version.compare.type.DynamicTable": "dynamic Table",
  "survey.version.compare.type.StaticTable": "static Table",
  "survey.version.compare.type.PredefinedList": "predefined List",
  "survey.version.compare.type.Text": "Text",
  "survey.version.compare.type.Number": "Number",
  "survey.version.compare.type.Radio": "Radio",
  "survey.version.compare.type.Checkbox": "Checkbox",
  "survey.version.compare.type.Dropdown": "Dropdown",
  "survey.version.compare.type.MatrixSingleChoice": "Matrix single choice",
  "survey.version.compare.type.MatrixMultipleChoice": "Matrix multiple choice",
  "survey.version.compare.type.Comment": "Comment",
  "survey.version.compare.type.Date": "Date",
  "survey.version.compare.type.Upload": "Upload",
  "survey.version.compare.type.ProjectData": "Project data",
  "survey.version.compare.type.InfoMessage": "Info message",
  "survey.version.compare.change.new": "new",
  "survey.version.compare.change.deleted": "deleted",
  "survey.version.compare.change.typeChange": "Type changed",
  "survey.version.compare.change.nameChange": "Name changed",
  "survey.version.compare.change.otherChange": "changes present",
  "survey.version.compare.current": "current",
  "survey.version.compare.view.pages": "By sections",
  "survey.version.compare.view.questions": "Questions only",
  "survey.version.compare.expand.all.pages": "Expand all sections",
  "survey.version.compare.collapse.all.pages": "Collapse all sections",
  "survey.version.compare.expand.all.questions": "Expand all questions",
  "survey.version.compare.collapse.all.questions": "Collapse all questions",
  "survey.version.compare.warning.duplicate.page.keys": "Duplicate section IDs are present. The comparison uses section IDs as keys, so duplicate section IDs cannot be matched unambiguously.",
  "survey.version.compare.warning.duplicate.keys": "Double ID is present. Please contact S12",
};
export default en;
